import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function UploadView({ onUpload }) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleFile = (file) => {
    if (file) {
      // Simulate reading/uploading delay
      setTimeout(() => onUpload(file), 600);
    }
  };

  const onDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className="w-full max-w-md mx-auto"
    >
      <div className="text-center mb-10">
        <h1 className="text-5xl font-extrabold tracking-tight mb-4">
          Resume <span className="text-gradient">Roast</span>
        </h1>
        <p className="text-slate-400 text-lg">
          Upload your resume. We'll tell you why you're not getting hired. Brutally.
        </p>
      </div>

      <div
        className={`glass-panel rounded-3xl p-8 text-center transition-all duration-300 cursor-pointer group ${
          isDragging ? 'border-rose-500 bg-rose-500/10' : 'hover:border-slate-600 hover:bg-slate-800/50'
        }`}
        onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={onDrop}
        onClick={() => fileInputRef.current?.click()}
      >
        <input 
          type="file" 
          ref={fileInputRef} 
          className="hidden" 
          accept=".pdf,.png,.jpg,.jpeg"
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
        
        <div className="w-20 h-20 mx-auto bg-slate-800 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-inner">
          <SafeIcon icon="UploadCloud" className="text-3xl text-rose-400" />
        </div>
        
        <h3 className="text-xl font-bold mb-2">Drop it like it's hot</h3>
        <p className="text-slate-400 text-sm mb-6">
          PDF, PNG, or JPG (Max 5MB)
        </p>

        <button className="bg-rose-500 hover:bg-rose-600 text-white font-bold py-3 px-8 rounded-full transition-colors w-full shadow-[0_0_20px_rgba(244,63,94,0.3)]">
          Select File
        </button>
      </div>

      <div className="mt-8 text-center text-xs text-slate-500 flex items-center justify-center gap-2">
        <SafeIcon icon="Shield" className="text-slate-400" />
        We don't store your data. It's roasted and deleted.
      </div>
    </motion.div>
  );
}